import React, { useState } from 'react';

import { WEB3FORMS_KEY, SCHOOL_NAME } from '../trainingInfo';

function EnrollForm() {
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  async function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const data = Object.fromEntries(new FormData(form));

    // Honeypot: real people never fill this hidden field.
    if (data.botcheck) return;

    setStatus('sending');
    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          ...data,
          access_key: WEB3FORMS_KEY,
          subject: `New CNA training inquiry from ${data.name}`,
          from_name: SCHOOL_NAME,
        }),
      });
      const json = await res.json();
      if (json.success) {
        setStatus('sent');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }
  }

  if (status === 'sent') {
    return (
      <div className='enroll_form enroll_sent' role='status'>
        <div className='enroll_sent_mark' aria-hidden='true'>&#10003;</div>
        <h3>Thank you!</h3>
        <p>We received your information and will contact you soon.</p>
        <button type='button' className='btn btn_ghost_dark' onClick={() => setStatus('idle')}>
          Send another
        </button>
      </div>
    );
  }

  return (
    <form className='enroll_form' onSubmit={handleSubmit}>
      <input type='checkbox' name='botcheck' className='hidden_field' tabIndex='-1' autoComplete='off' />

      <div className='field'>
        <label htmlFor='ef_name'>Full name</label>
        <input id='ef_name' name='name' type='text' autoComplete='name' required />
      </div>
      <div className='field_row'>
        <div className='field'>
          <label htmlFor='ef_phone'>Phone</label>
          <input id='ef_phone' name='phone' type='tel' autoComplete='tel' required />
        </div>
        <div className='field'>
          <label htmlFor='ef_email'>Email</label>
          <input id='ef_email' name='email' type='email' autoComplete='email' required />
        </div>
      </div>
      <div className='field'>
        <label htmlFor='ef_time'>Best time to reach you</label>
        <select id='ef_time' name='best_time' defaultValue='Any time'>
          <option>Any time</option>
          <option>Morning</option>
          <option>Afternoon</option>
          <option>Evening</option>
        </select>
      </div>
      <div className='field'>
        <label htmlFor='ef_message'>Questions <span className='optional'>(optional)</span></label>
        <textarea id='ef_message' name='message' rows='3'></textarea>
      </div>

      <button type='submit' className='btn btn_primary btn_full' disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending…' : 'Request information'}
      </button>
      {status === 'error' && (
        <p className='form_error' role='alert'>
          Something went wrong. Please try again or email us at{' '}
          <a href='mailto:rogart409@gmail.com'>rogart409@gmail.com</a>.
        </p>
      )}
    </form>
  );
}

export default EnrollForm;
